import { ComponentProps, FC, useCallback } from 'react';
import { FloatingEditButton } from '@bridebook/web/components/wedding-website/view-mode/partials/floating-edit-button/floating-edit-button';
import { PhotoTileBase } from '@bridebook/web/components/wedding-website/view-mode/partials/photo-tile-base/photo-tile-base';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useDispatch } from '@bridebook/web/lib/utils';
import { interactedWithWeddingWebsiteAnalyticsButtonClick } from '@bridebook/web/lib/wedding-website/analytics';
import { useEditorSyncContext } from '@bridebook/web/components/wedding-website/main/desktop/editor-sync-context';

interface IProps extends Omit<ComponentProps<typeof PhotoTileBase>, 'children'> {}

export const WeddingWebsitePhoto: FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const { triggerDetailsSync } = useEditorSyncContext();

  const handleEditPhoto = useCallback(() => {
    triggerDetailsSync('photos');
    dispatch(
      interactedWithWeddingWebsiteAnalyticsButtonClick({
        section: 'photos',
        element: 'editButton',
      }),
    );
  }, [dispatch, triggerDetailsSync]);
  return (
    <div className="group h-full w-full">
      <PhotoTileBase {...props}>
        <FloatingEditButton
          onClick={handleEditPhoto}
          href={UrlHelper.website.weddingDetails.sectionAnchor('photos')}
        />
      </PhotoTileBase>
    </div>
  );
};
